import Vue from 'vue';

import './vendors'
import App from './App.vue';
import router from './router/router'
import store from './store/store'
import VueAnalytics from 'vue-analytics';
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";


Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_MIX_GA_ID,
  router
})

Sentry.init({
    Vue,
    dsn: "https://d6a3c34dd7d64da9a77b494193668896@o357054.ingest.sentry.io/6172921",
    integrations: [
        new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ["localhost", "protokoll.digitalprotokoll.no", /^\//],
        }),
    ],
    tracesSampleRate: 1.0,
});

new Vue(
  Vue.util.extend({
    router, store
  }, App)
).$mount('#app');
